import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';

import { Subscription } from 'rxjs';
import { delay, filter, take, tap } from 'rxjs/operators';

import { layoutAnimation } from '@app-backoffice/layout/animations/layout.animation';

import { AuthHelperService } from '@lib-core/auth/services/auth-helper.service';
import { LayoutAnimationService } from '@lib-core/login/services/layout-animation.service';

@Component({
  selector: 'app-layout-blank',
  templateUrl: './layout-blank.component.html',
  styleUrls: ['./layout-blank.component.scss'],
  animations: [layoutAnimation],
  standalone: true,
  imports: [RouterOutlet],
})
export class LayoutBlankComponent implements OnInit, OnDestroy {
  // subscriptions
  private subscriptions: Subscription = new Subscription();

  // helpers
  isOpen = true;

  /**
   * constructor
   *
   */
  constructor(
    private router: Router,
    private authHelperService: AuthHelperService,
    public layoutAnimationService: LayoutAnimationService,
  ) {}

  /**
   * ngOnInit
   *
   */
  ngOnInit(): void {
    this.layoutAnimationService.init();

    // subscribe to enterAppAnimationCompleted
    this.subscriptions.add(
      this.layoutAnimationService.isEnterAppAnimationActive$
        .pipe(
          filter((isActive) => isActive),
          take(1),
          tap(() => (this.isOpen = false)),
          delay(300),
          tap(() => {
            this.router.navigate([this.authHelperService.getAppUrl()]).catch();
          }),
        )
        .subscribe(),
    );
  }

  /**
   * ngOnDestroy
   *
   */
  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
